import React, { useCallback, useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import PageHeader, { ActionRow, EmptyState } from "@/components/PageHeader";
import { ThespianRankCard } from "@/components/thespian/ThespianRankCard";
import ThespianClaimDialog from "@/components/thespian/ThespianClaimDialog";
import ThespianExportDialog from "@/components/thespian/ThespianExportDialog";
import ThespianClaimsList from "@/components/thespian/ThespianClaimsList";
import api from "@/lib/api";

export default function MemberThespian() {
  const [data, setData] = useState(null);
  const [activities, setActivities] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  const load = useCallback(() => {
    api.get("/thespian/my").then(({ data: d }) => setData(d)).catch(() => {});
    api.get("/thespian/activities").then(({ data: d }) => setActivities(d.items || [])).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const openClaim = (c = null) => { setEditing(c); setOpen(true); };
  const items = data?.items || [];

  return (
    <div>
      <PageHeader title="Thespian Points" subtitle="Claim International Thespian Society points and track your ITS rank"
        actions={data?.approved_count > 0 && <ThespianExportDialog endpoint="/thespian/my/export" own />} />
      {data?.enabled && <div className="mb-6"><ThespianRankCard summary={data} /></div>}

      <ActionRow testId="thespian-new-claim-row">
        <Button onClick={() => openClaim()} className="rounded-full bg-amber-700 hover:bg-amber-800" data-testid="thespian-new-claim-btn"><Plus className="mr-2 h-4 w-4" /> New claim</Button>
      </ActionRow>

      {items.length === 0 ? (
        <EmptyState title="No claims yet" description="Submit your first ITS point claim to start working toward induction." testId="thespian-empty" />
      ) : (
        <ThespianClaimsList items={items} onEdit={openClaim} />
      )}

      <ThespianClaimDialog open={open} setOpen={setOpen} activities={activities} editing={editing} onDone={load} />
    </div>
  );
}
